module.exports = __webpack_public_path__ + "static/img/money-explain3.48731c73.png";